import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { RefreshCw, Download } from "lucide-react";

const StatsPanel = ({ mood, isAnalyzing, onExportPDF }) => {
  const { t } = useTranslation();
  
  if (!mood) return null;

  return (
    <div className="p-4" data-testid="stats-panel">
      <div className="stats-grid mb-4">
        <div className="stat-card">
          <div className="stat-value">{mood.headlines_analyzed || 0}</div>
          <div className="stat-label">{t('headlines')}</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{mood.sources_used?.length || 0}</div>
          <div className="stat-label">{t('sources')}</div>
        </div>
        <div className="stat-card">
          <div className="stat-value" style={{ color: mood.color }}>
            {Math.round((mood.intensity || 0) * 100)}%
          </div>
          <div className="stat-label">{t('intensity')}</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">
            {isAnalyzing ? (
              <RefreshCw size={20} className="animate-spin mx-auto" style={{ color: 'var(--apple-blue)' }} />
            ) : (
              <span style={{ color: 'var(--apple-green)' }}>{t('live')}</span>
            )}
          </div>
          <div className="stat-label">{t('status')}</div>
        </div>
      </div>
      <button onClick={onExportPDF} className="apple-button apple-button-primary w-full" data-testid="export-pdf-btn">
        <Download size={16} className="inline mr-2" />
        {t('exportReport')}
      </button>
    </div>
  );
};

export { StatsPanel };
